import React, {useEffect, useState} from "react";
import {Button, MenuItem} from "@material-ui/core";
import DialogTitle from "@material-ui/core/DialogTitle";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import {Country} from "../../models/domain-of-responsibility.models";
import Grid from "@material-ui/core/Grid";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import {run} from "../../utils/function-util";
import {useApiNotification} from "../ui/ApiNotificationProvider";
import DialogContent from "@material-ui/core/DialogContent";
import {getAvailableSupportUnitCountries} from "../../api/support-unit-functions";
import {useTranslation} from "react-i18next";

export interface ApplyCountryCodeDialogArg {
    readonly supportUnitId: number,
    readonly open: boolean,
    readonly onSelected: (countryId: Country | null) => Promise<void> | void,
}

export const ApplyCountryCodeDialog: React.FC<ApplyCountryCodeDialogArg> = ({supportUnitId, open, onSelected}) => {
    const {handleError} = useApiNotification();
    const {t} = useTranslation();
    const [countries, setCountries] = useState<Country[]>([]);
    const [selected, setSelected] = useState<number | null>(null);

    useEffect(run(() => getAvailableSupportUnitCountries(supportUnitId),
        (cs: Country[]) => setCountries(cs),
        handleError
    ), [supportUnitId]);

    function handleChange(event: any) {
        const countryId: number = event.target.value;
        setSelected(countryId > 0 ? countryId : null);
    }

    return (
        <Dialog open={open}>
            <DialogTitle>{t('SupportUnit.CountryCode.Title')}</DialogTitle>
            <DialogContent>
                <Grid container direction="column">
                    <InputLabel id="select-country-label">{t('SupportUnit.CountryCode.Label')}</InputLabel>
                    <Select labelId="select-country-label"
                            label={t('SupportUnit.CountryCode.Hint')}
                            value={selected}
                            onChange={handleChange}>
                        {countries.map((c: Country) => <MenuItem key={c.id}
                                                                 value={c.id}>{c.name} ({c.twoLetterIsoCode})</MenuItem>)}
                    </Select>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button onClick={() => {setSelected(null); onSelected(null);}}>
                    {t('SupportUnit.CountryCode.Actions.Cancel')}
                </Button>
                <Button disabled={!selected || selected === 0}
                        onClick={() => onSelected(countries.find(c => c.id === selected) ?? null)}>
                    {t('SupportUnit.CountryCode.Actions.Select')}
                </Button>
            </DialogActions>
        </Dialog>
    );
}
